var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconErrorMotivation = function SvgIconErrorMotivation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.9 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.9,
    cy: 4,
    r: 3.5,
    stroke: "#D61E3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3.7 2.8 2.4 2.4M6.1 2.8 3.7 5.2",
    stroke: "#D61E3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgIconErrorMotivation as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOSA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC44OTk5MDIgNEMwLjg5OTkwMiAxLjc5MDg2IDIuNjkwNzYgMCA0Ljg5OTkgMEM3LjEwOTA0IDAgOC44OTk5IDEuNzkwODYgOC44OTk5IDRDOC44OTk5IDYuMjA5MTQgNy4xMDkwNCA4IDQuODk5OSA4QzIuNjkwNzYgOCAwLjg5OTkwMiA2LjIwOTE0IDAuODk5OTAyIDRaIiBmaWxsPSJ3aGl0ZSIvPgo8Y2lyY2xlIGN4PSI0Ljg5OTkiIGN5PSI0IiByPSIzLjUiIHN0cm9rZT0iI0Q2MUUzRCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0zLjY5OTcxIDIuNzk5OTlMNi4wOTk3MSA1LjE5OTk5IiBzdHJva2U9IiNENjFFM0QiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNi4xMDAxIDIuNzk5OTlMMy43MDAxIDUuMTk5OTkiIHN0cm9rZT0iI0Q2MUUzRCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";